// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const resetReport = () =>

    dispatch => {

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_CRITERIA
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_DEALERS
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL
        });

        dispatch({
            type: actions.RESET_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES
        });

    };



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/reset-report.js